import React, { useEffect, useState } from "react";
import styles from "./DashboardMetrics.module.css";
import { BACKEND_URL } from "../config";

export default function DashboardMetrics({ range }) {
  const [metrics, setMetrics] = useState({});

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/report/metrics?range=${range}`)
      .then((r) => r.json())
      .then((m) => setMetrics(m))
      .catch(console.error);
  }, [range]);

  return (
    <div className={styles.dashboardMetricsGrid}>
      <Card title="Orders to Accept" value={metrics.orders_to_accept} />
      <Card title="Orders in Transit" value={metrics.orders_in_transit} />
      <Card title="Orders to Pickup" value={metrics.orders_to_pickup} />
      <Card title="Total Orders" value={metrics.total_orders_today} />
      <Card title="Delivered" value={metrics.delivered_today} />

      <Card title="Pending" value={metrics.pending_today} />
      <Card title="Cancelled" value={metrics.total_cancelled} />
      <Card title="Revenue (Month)" value={metrics.total_revenue_month} />
      <Card
        title="Avg Delivery Time"
        value={metrics.avg_delivery_time ?? "-"}
      />
      <Card
        title="Success Rate"
        value={metrics.delivery_success_rate ? metrics.delivery_success_rate + "%" : "-"}
      />
    </div>
  );
}

function Card({ title, value }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>{title}</div>
      <div className={styles.cardValue}>{value ?? "-"}</div>
    </div>
  );
}
